export default {
    entityKey: 'accounts'
}
